export default {
    entityKey: 'accounts'
}
